/** Centralised route path constants — import these instead of hard-coding paths. */
export const routes = {
  home: '/',
  about: '/about',
  method: '/method',
  services: '/services',
  programs: '/programs',
  gallery: '/gallery',
  contact: '/contact',
} as const;

export type RouteKey = keyof typeof routes;
